









import { Component, Vue, Prop } from "vue-property-decorator";
import Biaodan from "./biaodan.vue";
@Component({
  components: {
    Biaodan
  }
})
export default class Jibingchufang extends Vue {
  @Prop()
  private model: any;
  @Prop()
  private message: any;
  private messageChange(message) {
    this.$emit("update:message", message);
  }
}
